import React, { useState } from "react";
import UploadPage from "./UploadPage";
import DatabaseImportPage from "./DatabaseImportPage"; 
import DatabaseMappingPage from "./DatabaseMappingPage"; 
import "./UnifiedPage.css";
import "./DatabaseUnifiedPage.css";

const DatabaseUnifiedPage = () => {
  const [showMappingPage, setShowMappingPage] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  return (
    <div className="unified-page">
      <h1>Datenbank Import</h1>

      <div className="section">
        <h2>1. CSV-Daten Hochladen</h2>
        <div className="component-wrapper">
          <UploadPage />
        </div>
      </div>

      <div className="section">
        <h2>2. Datenbank abrufen</h2>
        <div className="component-wrapper">
          <DatabaseImportPage setShowMappingPage={setShowMappingPage} setRefreshTrigger={setRefreshTrigger} />
        </div>
      </div>

      {showMappingPage && (
        <div className="section">
          <h2>3. Datenbank Mapping</h2>
          <div className="component-wrapper">
            <DatabaseMappingPage key={refreshTrigger} refreshTrigger={refreshTrigger} />
          </div>
        </div>
      )}
    </div>
  );
};

export default DatabaseUnifiedPage;